import { Link } from 'react-router-dom';

export const AboutPage = () => {
  return (
    <div>
      {/* Hero */}
      <section style={{ backgroundColor: 'var(--bg-inverse)' }}>
        <div
          className="container-main text-center hero-section"
          style={{
            paddingTop: 'var(--space-16)',
            paddingBottom: 'var(--space-16)',
            maxWidth: '720px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <h1
            style={{
              fontSize: 'var(--text-hero)',
              fontWeight: 'var(--font-weight-bold)',
              lineHeight: 'var(--leading-tight)',
              letterSpacing: 'var(--tracking-tight)',
              color: 'var(--text-inverse)',
            }}
          >
            About{' '}
            <span style={{ color: 'var(--color-primary-400)' }}>
              Ribbon Studios
            </span>
          </h1>
          <p
            style={{
              marginTop: 'var(--space-6)',
              fontSize: 'var(--text-lg)',
              lineHeight: 'var(--leading-relaxed)',
              color: 'var(--color-neutral-300)',
              fontWeight: 'var(--font-weight-light)',
            }}
          >
            We're a software company that happened to buy a 3D printer.
          </p>
        </div>
      </section>

      {/* The Operation */}
      <section
        className="container-main"
        style={{
          paddingTop: 'var(--space-20)',
          paddingBottom: 'var(--space-20)',
          maxWidth: '720px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <h2
          style={{
            fontSize: 'var(--text-3xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          The Story
        </h2>
        <p
          style={{
            marginTop: 'var(--space-4)',
            fontSize: 'var(--text-base)',
            lineHeight: 'var(--leading-relaxed)',
            color: 'var(--text-secondary)',
          }}
        >
          <a
            href="https://www.ribbonstudios.org/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'var(--text-accent)',
              textDecoration: 'none',
              fontWeight: 'var(--font-weight-medium)',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
            onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
          >
            Ribbon Studios
          </a>{' '}
          is Ryan and Jordan. We mostly build software -- web apps, mobile
          apps, games, that kind of thing.
        </p>
        <p
          style={{
            marginTop: 'var(--space-4)',
            fontSize: 'var(--text-base)',
            lineHeight: 'var(--leading-relaxed)',
            color: 'var(--text-secondary)',
          }}
        >
          The 3D printing thing happened because Ryan impulse-bought a
          printer and it sat in the corner not doing much. Rather than let it
          collect dust, we figured we'd put it to use and let other people
          get stuff printed.
        </p>
        <p
          style={{
            marginTop: 'var(--space-4)',
            fontSize: 'var(--text-base)',
            lineHeight: 'var(--leading-relaxed)',
            color: 'var(--text-secondary)',
          }}
        >
          Ryan runs the whole printing side -- prints, checks, packs, and
          ships everything himself. It's small, and that's the point. Bad
          print? It gets redone. Got a question? You're talking to the person
          who made your order.
        </p>
      </section>

      {/* Equipment */}
      <section
        style={{
          backgroundColor: 'var(--bg-surface)',
          borderTop: '1px solid var(--border-subtle)',
          borderBottom: '1px solid var(--border-subtle)',
        }}
      >
        <div
          className="container-main"
          style={{
            paddingTop: 'var(--space-20)',
            paddingBottom: 'var(--space-20)',
            maxWidth: '720px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <h2
            style={{
              fontSize: 'var(--text-3xl)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--text-primary)',
              letterSpacing: 'var(--tracking-tight)',
            }}
          >
            What we print with
          </h2>
          <div
            className="grid sm:grid-cols-2"
            style={{
              marginTop: 'var(--space-8)',
              gap: 'var(--space-6)',
            }}
          >
            <EquipmentCard
              name="Bambu Lab P1S"
              type="3D Printer"
              details={[
                'Enclosed, high-speed Core XY',
                '0.4mm and 0.6mm nozzles',
                'Auto bed leveling',
              ]}
            />
            <EquipmentCard
              name="Bambu Lab AMS 2 Pro"
              type="Automatic Material System"
              details={[
                'Swaps filament automatically',
                'Up to 4 colors per print',
                'Keeps filament dry in storage',
              ]}
            />
          </div>
        </div>
      </section>

      {/* Location */}
      <section
        className="container-main"
        style={{
          paddingTop: 'var(--space-20)',
          paddingBottom: 'var(--space-20)',
          maxWidth: '720px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <h2
          style={{
            fontSize: 'var(--text-3xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          Shipping
        </h2>
        <p
          style={{
            marginTop: 'var(--space-4)',
            fontSize: 'var(--text-base)',
            lineHeight: 'var(--leading-relaxed)',
            color: 'var(--text-secondary)',
          }}
        >
          We're in Texas and ship across the US. Most orders go out within a
          few business days, depending on how busy the queue is.
        </p>
      </section>

      {/* CTA */}
      <section
        style={{
          backgroundColor: 'var(--bg-inverse)',
          borderTop: '1px solid var(--color-neutral-800)',
        }}
      >
        <div
          className="container-main text-center"
          style={{
            paddingTop: 'var(--space-12)',
            paddingBottom: 'var(--space-12)',
            maxWidth: '640px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <h2
            style={{
              fontSize: 'var(--text-2xl)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--text-inverse)',
              letterSpacing: 'var(--tracking-tight)',
            }}
          >
            Ready to get something printed?
          </h2>
          <p
            style={{
              marginTop: 'var(--space-3)',
              color: 'var(--color-neutral-400)',
              lineHeight: 'var(--leading-relaxed)',
            }}
          >
            Upload your 3MF file and get an instant quote, or browse the
            catalog for ready-made items.
          </p>
          <div
            className="flex flex-col sm:flex-row items-center justify-center"
            style={{ marginTop: 'var(--space-6)', gap: 'var(--space-4)' }}
          >
            <Link
              to="/quote"
              className="focus-ring hero-cta-button"
              style={{
                backgroundColor: 'var(--color-primary-600)',
                color: 'var(--text-inverse)',
                padding: 'var(--space-3) var(--space-6)',
                borderRadius: 'var(--radius-lg)',
                fontSize: 'var(--text-base)',
                fontWeight: 'var(--font-weight-semibold)',
                textDecoration: 'none',
                textAlign: 'center',
                transition: `background-color var(--duration-fast) var(--ease-out)`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  'var(--color-primary-500)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  'var(--color-primary-600)';
              }}
            >
              Get an Instant Quote
            </Link>
            <Link
              to="/catalog"
              className="focus-ring hero-cta-button"
              style={{
                border: '1px solid var(--color-neutral-600)',
                color: 'var(--text-inverse)',
                padding: 'var(--space-3) var(--space-6)',
                borderRadius: 'var(--radius-lg)',
                fontSize: 'var(--text-base)',
                fontWeight: 'var(--font-weight-semibold)',
                textDecoration: 'none',
                textAlign: 'center',
                transition: `background-color var(--duration-fast) var(--ease-out)`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  'var(--color-neutral-800)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              Browse Catalog
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

const EquipmentCard = ({
  name,
  type,
  details,
}: {
  name: string;
  type: string;
  details: readonly string[];
}) => (
  <div
    style={{
      backgroundColor: 'var(--bg-surface-raised)',
      padding: 'var(--space-6)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-sm)',
    }}
  >
    <h3
      style={{
        fontSize: 'var(--text-lg)',
        fontWeight: 'var(--font-weight-semibold)',
        color: 'var(--text-primary)',
      }}
    >
      {name}
    </h3>
    <p
      style={{
        marginTop: 'var(--space-1)',
        fontSize: 'var(--text-sm)',
        color: 'var(--text-accent)',
        fontWeight: 'var(--font-weight-medium)',
      }}
    >
      {type}
    </p>
    <ul
      style={{
        marginTop: 'var(--space-4)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-2)',
        listStyle: 'none',
        padding: 0,
      }}
    >
      {details.map((detail) => (
        <li
          key={detail}
          style={{
            fontSize: 'var(--text-sm)',
            color: 'var(--text-secondary)',
            lineHeight: 'var(--leading-relaxed)',
            paddingLeft: 'var(--space-4)',
            position: 'relative',
          }}
        >
          <span
            style={{
              position: 'absolute',
              left: 0,
              color: 'var(--color-primary-500)',
            }}
            aria-hidden="true"
          >
            -
          </span>
          {detail}
        </li>
      ))}
    </ul>
  </div>
);
